import styled from 'styled-components';
import { tabsBorder } from 'styles/Colors';

export const DialogFooterWrapper = styled.div`
  flex-shrink: 0;
  height: 80px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  padding: 0 32px 0 16px;
  border-top: 1px solid ${tabsBorder};
`;

export const RightSide = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 16px;
`;
